module.exports = "/_next/static/images/PipeDataIntoWarehouse@2x-67026d0d0daadacd4d659bf000f2c291.png";